<template>
    <div class="col-12">
      <div class="search-padd">
      <form v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading menu_heading_1"></div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="admin_details" id="mentee_details_more">
            <div class="crm_admin_field_lists menu_heading_1">
              <div class="search-padd">
                <button
                    v-if="isActive"
                    type="button"
                    id="account_status"
                    class="btn btn-sm ma-gray-btn"
                    name="account_status"
                    v-on:click="updateAccountStatus('Inactive');">
                    Inactivate Account
                </button>
                <button
                    v-if="isInActive"
                    type="button"
                    id="account_status"
                    class="btn btn-sm ma-gray-btn"
                    name="account_status"
                    v-on:click="updateAccountStatus('Delete');">
                    Delete Account
                </button>
                <div v-if="accountStatus == 'Delete'" class="alert alert-danger">Account is deleted</div>
                <div v-if="accountStatus == 'Prospect'" class="alert alert-danger">Account is Prospect</div>
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
        </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { store } from '../../store/store';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'accountStatus'],
      data() {
        return {
          loading: true,
          statusText: ''
        }
      },
      computed: {
        isActive() {
          if (this.accountStatus == 'Active') {
            return true;
          }
        },
        isInActive() {
          if (this.accountStatus == 'Inactive') {
            return true;
          }
        }
      },
      methods: {
        updateAccountStatus(statusName) {
            this.loading = true;
            axios("/update_account_status", {
                method: 'POST',
                data: {
                    account_id: this.accountId,
                    status: statusName,
                }
            })
            .then(response => {
              this.loading = false;
              var flashMsg = '';
              if (statusName == 'Inactive') {
                flashMsg = 'Account Inactivated';
              }
              if (statusName == 'Delete') {
                flashMsg = 'Account Deleted';
              }
              this.flash({ message: flashMsg, variant: 'success' });
              this.$router.push(this.$router.currentRoute.fullPath)
              this.$router.go();
            })
            .catch(error => {
            });
        }  
      },
      created: function () {
        this.account_type = this.$parent.org_type;
        this.loading = false;
      },
    }
</script>
<style scoped>
.menu_heading_1 {
  width: 100%;
}
.ma-gray-btn, .ma-gray-btn:active .ma-gray-btn:hover, .ma-gray-btn:focus {
    color: #FFF !important;
    border: 1px solid #bcb8b8 !important;
    background: #bcb8b8 !important;
    padding: 5px; 
    font-weight: 900;
    width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_menu_tab.vue